/**
 * OptionChip — a selectable pill button for preset choices.
 *
 * Used in the alarm control panel for preset time selections
 * (e.g. "15 minutes", "1 hour", "4 hours", "Until 6am").
 */
import { type FC, memo } from "react";
import { Pressable, type StyleProp, type ViewStyle } from "react-native";
import "../../theme"; // module augmentation for react-native-unistyles types
import { StyleSheet } from "react-native-unistyles";
import { View } from "../View";
import { Text } from "../Text";

export interface OptionChipProps {
  readonly label: string;
  readonly onPress: () => void;
  readonly selected: boolean;
  readonly style?: StyleProp<ViewStyle>;
}

export const OptionChip: FC<OptionChipProps> = memo(({ label, onPress, selected, style }) => {
  return (
    <View flex={1} style={{ minWidth: 0 }}>
      <Pressable onPress={onPress} style={[styles.button, selected ? styles.buttonSelected : undefined, style]}>
        <Text textStyle="sm/regular" color="text">
          {label}
        </Text>
      </Pressable>
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  button: {
    padding: theme.spacing.xl,
    borderRadius: theme.spacing.xl,
    backgroundColor: theme.colors.foreground,
    borderColor: theme.colors.border,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    height: 48,
  },
  buttonSelected: {
    borderColor: theme.colors.interactive.buttons.default_background,
  },
}));
